import { z } from 'zod';

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' };
  }
  return { message: ctx.defaultError };
});

const validatePositiveValue = (value: string) => {
  const numericValue = parseFloat(value.replace(/[^\d-]/g, '')) / 100;
  return numericValue >= 0;
};

export const productSchema = z.object({
  id: z.union([z.number().int(), z.string()]).optional(),
  nome: z.string().min(1, 'O nome não pode ser vazio'),
  imagem: z.string().default('https://no-image-example.aaaaaaaa').optional(),
  descricao: z.string(),
  vendaOnline: z.boolean().default(false),
  valor: z.string().min(1, 'O valor não pode ser vazio').refine(validatePositiveValue, 'O valor não pode ser negativo'),
  valorCusto: z.string().min(1, 'O valor não pode ser vazio').refine(validatePositiveValue, 'O valor não pode ser negativo'),
  maxParcelas: z.number().default(1),
  quantidadeEstoque: z.number().default(0),
  tipoComissao: z.string().optional(),
  valorComissao: z.string().min(1, 'O valor não pode ser vazio').refine(validatePositiveValue, 'O valor não pode ser negativo'),
  categoriaProduto: z.object({
    id: z.union([
      z.number().int().min(1, 'Selecione uma Categoria de produto'),
      z.string().min(1, 'Selecione uma Categoria de produto'),
    ]),
  }),
  movimentarEstoque: z.boolean().default(true),
  unidade: z.object({ id: z.union([z.number().int(), z.string()]) }),
  centroCusto: z.object({
    id: z.union([
      z.number().int().min(1, 'Selecione um Centro de Custo'),
      z.string().min(1, 'Selecione um Centro de Custo'),
    ]),
  }),
  valorDesconto: z.string().min(1, 'O valor não pode ser vazio').refine(validatePositiveValue, 'O valor não pode ser negativo'),
});

export type productForm = z.infer<typeof productSchema>;
